export default "__VITE_ASSET__NbzQHDI0__"